"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Actions_meta_1 = require("../Actions.meta");

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('section', Actions_meta_1.ACTIONS_CATEGORY_KEY, Actions_meta_1.ACTIONS_COMPONENT_KEY, ['wrapper']);